// extracted by mini-css-extract-plugin
export default {"h2hWarning":"FilterHeadToHeadWarning_h2hWarning__ziT6m"};